import { AppSettings, PaymentMethodIdEnum, ShippingMethodDeliveryType } from "@core/types";

const aboutCompanyHtml = `
  <h3>Доставка продуктов на дом в Грозном.</h3>
  Parhato.ru — это онлайн-магазин по доставке товаров на дом и в офис в Грозном.
  <br />
   В нашем интернет-магазине представлен широкий ассортимент продуктов питания и других товаров, начиная от детского питания и заканчивая бытовой химией. Заказ собирается на складе, где строго соблюдаются правила товарного соседства и контроль сроков годности. Для доставки продуктов используются соответствующие автомобили, способные обеспечить сохранность товара и необходимую температуру. Каждый товар проходит тщательный контроль качества.
   <br />
   Благодаря своевременной доставке, в том числе и в  день заказа или в день праздника, и коротким временным  интервалам получения, Parhato.ru обеспечивает высокий уровень сервиса. Купить свежие продукты питания с доставкой на дом в Грозном можно на сайте интернет-магазина, в мобильном приложении, с помощью <a href="tel:+79287375050">контактного центра</a> или<a href="https://parhato.ru/contacts/"> других видов связи,</a> представленных на сайте. Наш курьер доставит заказ до двери.
   <br />
   Наш онлайн-супермаркет всегда радует своих клиентов выгодными предложениями, <a href="https://app.parhato.ru/products/0/0/sale/">акциями</a>, новинками и доступными ценами.
   <br />
   Parhato2.ru - удобство и качество!
  `;

export const Config: AppSettings = {
  liveUpdate: {
    url: "",
    version: "",
    enabled: true,
  },
  supaBaseMediaUrl: "https://proxy2.parhato.ru/supa/storage/v1/object/public/",
  appUrl: "https://app.parhato.ru",
  exitAppICantGoBack: false,
  isOffertaPageEnabled: true,
  haveTabs: false,
  baseUrl: process.env.REACT_APP_PARHATO_2_URL || "https://proxy2.parhato.ru",
  imageUrlPrefix: "https://cdn2.parhato.ru/storage/v1/object/public/",
  CDNDomain: "cdn2.parhato.ru",
  sharedData: {
    title: "Parhato",
    text: `Parhato - это ваш личный помощник по доставке продуктов и других различных товаров, начиная от детского питания и заканчивая бытовой химией.\n\n`,
    androidUrl: "https://play.google.com/store/apps/details?id=ru.parhato.app",
    iosUrl: "https://apps.apple.com/ru/app/parhato/id1572201263",
  },

  minimumOrderAmount: 500,
  shouldCheckItemsAvailability: false,
  showProductReviews: true,
  showCouponsInCart: true,

  isBonusPointsEnabled: true,
  isDeliveryDateEnabled: true,
  orderHistoryPagination: true,
  isCustomerAdressesEnabled: true,
  isReferralEnabled: true,
  isReferralBannerEnabled: true,
  isReferralStatsEnabled: true,
  isAdditionalPageEnabled: true,

  signUpPage: {
    nameFieldEnabled: false,
    lastNameFieldEnabled: false,
  },

  deleteAccountLink: "https://parhato.ru/delete-me/",
  showSendCustomerRequestButton: false,
  cardProduct: false,
  updateUserForm: {
    isUpdatePasswordEnabled: true,
    showPhoneNumberInput: true,
  },
  isOnlinePaymentEnabled: false,
  privacyPolicyPageLink: "https://parhato.ru/privacy/",
  isSeoOnHomePageEnabled: true,
  companyPhoneNumber: "+7 (928) 737-50-50",
  isContentInFooterShown: true,
  hasCardLoyalty: false,
  showSliderCatalogButton: false,
  addressSettings: {
    showCustomerAddresses: true,
    showFlatDelivery: true,
    addressInputDependsOnShippingMethod: false,
  },
  homePageCategories: {
    customersChoice: { title: "Customers Choice", isEnabled: true },
    featured: { title: "Featured Products", isEnabled: true },
    sale: { title: "On Sale Products", isEnabled: true },
    latest: { title: "Latest Addest", isEnabled: true },
  },
  isExpressDeliveryEnabled: false,
  showNewVersionAlert: true,
  wishListIcons: true,
  showOrderPageProductCardCounter: false,
  cartMinAmountFromMethods: true,
  siteDomain: "parhato.ru",

  loginPage: {
    phoneOrEmailFieldEnabled: true,
  },
  orderDetailPage: {
    reviewOrderEnabled: true,
    repeatOrderEnabled: true,
    cancelOrderEnabled: true,
  },
  newProductDuration: 20,
  homeSliderAutoplaySeconds: 10,
  image: {
    isDownSizeEnabled: false,
    isLazyLoadingEnabled: true,
    base64Extension: "webp",
    isNeedBase65Prefix: false,
    isBase64InSrc: false,
  },
  showStockQuantity: false,
  lowStockThresholdToShowPercent: 10,
  minLowStockThresholdToShowNumber: 10,
  appIosId: "1572201263",
  search: {
    inputDebounceTimeMs: 500,
    minSearchLength: 3,
  },
  usePriceHTML: true,
  headquarters: [43.315434, 45.68801],
  isNecessaryToCreateAddress: true,
  contacts: [],
  requisites: [],
  aboutCompanyHtml: aboutCompanyHtml,
  defineSiteActivity: "это доставка продуктов питания, бытовой химии и текстиля.",
  isUnavailableProductsEnabled: true,
  customerSurvey: {
    isEnabled: false,
    allowDismiss: true,
  },

  shipping: {
    showCurrentShippingAddressSelect: true,
    showDefaultShippingZone: true,
    showOldAddressInputOnShippingPage: true,
    isShippingZonesEnabled: true,
  },
  isStoriesEnabled: true,
  isInviteEnabled: true,
  hasClientToDeleteUser: false,
  isCardsEnabled: true,
  pages: {
    authPageName: "parhato2",
    homePageName: "parhato2",
    myOrdersPageName: "parhato2",
    searchMainCategoriesPageName: "parhato2",
    cartPageName: "parhato2",
    myAccountPageName: "parhato2",
    thankYouPageName: "parhato2",
    subCategoriesPageName: "parhato2",
    orderDetailPageName: "parhato2",
    wishlistPageName: "parhato2",
    productDetailPageName: "common",
  },
  isPaymentsEnabled: false,
  isSettingsPageEnabled: true,

  notifications: {
    cartRemindDelayMinutes: 15,
    isOrderNotificationsEnabled: false,
    isDiscountNotificationsEnabled: false,

    orderNotifications: {
      isPushEnabled: false,
    },

    discountNotifications: {
      isPushEnabled: false,
      isEmailEnabled: false,
      isSmsEnabled: false,
    },
  },
  isEmailPushEnabled: false,
  isCartProgressButtonEnabled: true,
  isCartQuantityInputEnabled: true,
  isWeightProductQuantityStepEnabled: true,
  showUnavailableProductsModal: false,
  isImageInCartStoreEnabled: true,
  isShouldRecalculatePriceOnReplace: false,
  isToggleSwitchModuleEnabled: false,
  moduleOnInit: "PARHATO2",
  maxWeightForOrderKG: 120,
  maxWeightForFeeKG: 30,
  maxWeightFeeStep: 10,
  extraWeightFee: 50,
  isWeightFeeEnabled: true,
  expressMaxWeightKg: 10,
  inviteFriendDesc: `Приглашайте друзей и получайте баллы за каждого`,
  inviteFriendTerms: `Начислим 1% всех покупок от приглашенных друзей`,
  maxVisibleProductsOnHome: 12,
  isCartSyncEnabled: false,
  showStockStatus: false,
  shareProduct: false,
  showParentName: false,
  isDeliveryIntervalEnabled: true,
  isLocalNotificationsEnabled: true,
  isFCMNotificationsEnabled: true,
  staticOrderDataEnabled: true,
  staticOrderData: {
    deliveryIntervals: [
      { id: "1", text: "10:00 - 12:00" },
      { id: "2", text: "12:00 - 14:00" },
      { id: "3", text: "14:00 - 16:00" },
      { id: "4", text: "16:00 - 18:00" },
      { id: "5", text: "18:00 - 20:00" },
      { id: "6", text: "20:00 - 22:00" },
      { id: "7", text: "22:00 - 23:59" },
    ],
    blockedIntervals: [
      {
        deliveryIntervalId: "2",
        dayOfWeek: 5,
      },
    ],
    shippingZones: [
      { id: "9", name: "Гудермес" },
      { id: "10", name: "Аргун" },
      { id: "11", name: "Урус-Мартан" },
      { id: "12", name: "Ачхой-Мартан" },
      { id: "13", name: "Шали" },
      { id: "14", name: "Курчалой" },
      { id: "15", name: "Ножай-Юрт" },
      { id: "16", name: "Шатой" },
      { id: "17", name: "Шелковская" },
      { id: "18", name: "Старые-Атаги" },
      { id: "19", name: "Знаменское" },
      { id: "8", name: "Грозный" },
      { id: "20", name: "С. Беркат-Юрт" },
    ],

    paymentMethods: [
      {
        id: "1",
        enabled: true,
        title: "Наличная оплата",
        type: PaymentMethodIdEnum.cash,
      },
      {
        id: "2",
        enabled: true,
        title: "Безналичная оплата",
        type: PaymentMethodIdEnum.card,
      },
    ],
    shippingMethods: [
      {
        methodDeliveryType: ShippingMethodDeliveryType.default,
        methodType: "NEXTDAY" as any,
        id: "1",
        methodId: "1",
        description: "Курьерская доставка до дома",
        enabled: true,
        cost: "0",
        title: "Курьер",
        minAmount: "9000",
      },
      {
        methodDeliveryType: ShippingMethodDeliveryType.default,
        methodType: "DEFAULT",
        id: "4",
        methodId: "4",
        description: "Доставка до 2000р",
        enabled: true,
        cost: "149",
        title: "Стандартная ставка",
        minAmount: "500",
      },
      {
        methodDeliveryType: ShippingMethodDeliveryType.default,
        methodType: "DEFAULT" as any,
        id: "3",
        methodId: "3",
        description: "Бесплатная доставка от 2000р. по г.Грозный",
        enabled: true,
        cost: "0",
        title: "Бесплатная доставка по городу",
        minAmount: "2000",
      },
    ],
    shippingZoneMethods: [
      { id: 1, shippingMethodId: 3, shippingZoneId: 8 },
      { id: 2, shippingMethodId: 4, shippingZoneId: 8 },
      { id: 3, shippingMethodId: 1, shippingZoneId: 9 },
      { id: 4, shippingMethodId: 1, shippingZoneId: 10 },
      { id: 5, shippingMethodId: 1, shippingZoneId: 11 },
      { id: 6, shippingMethodId: 1, shippingZoneId: 12 },
      { id: 7, shippingMethodId: 1, shippingZoneId: 13 },
      { id: 8, shippingMethodId: 1, shippingZoneId: 14 },
      { id: 9, shippingMethodId: 1, shippingZoneId: 15 },
      { id: 10, shippingMethodId: 1, shippingZoneId: 16 },
      { id: 11, shippingMethodId: 1, shippingZoneId: 17 },
      { id: 12, shippingMethodId: 1, shippingZoneId: 18 },
      { id: 13, shippingMethodId: 1, shippingZoneId: 19 },
      { id: 14, shippingMethodId: 1, shippingZoneId: 20 },
    ],
  },
  appMetrica: {
    enabled: true,
    apiKey: process.env.REACT_APP_PARHATO_APPMETRICA_API_KEY!,
  },
  expressAllowedTimeStart: "10:00",
  expressAllowedTimeEnd: "23:59",
  isNotificationsPageEnabled: false,
  orderTrackingEnabled: true,
  isInviteePurchasesEnabled: true,
  isProductSubscriptionsEnabled: true,
  telegramAuth: {
    enabled: true,
    botUsername: "parhatoapi_bot",
  },
  defaultShippingZoneId: "8",
  offertaUrl: "https://proxy2.parhato.ru/supa/storage/v1/object/public/documents/oferta.pdf",
  director: "Вахабов Салавди Касумович",
  innKpp: "2014044690 / 201401001",
  legalAddress: "366020, Чеченская Республика, г. Грозный, р-н Ахматовский, ул. Им. У.Д. Димаева, д. 14, офис 01/29",
  orgName: "ООО «Пархато»",
  ogrn: "1252000001373 от 17 февраля 2025 г.",
  isUpdateNotificationEnabled: false,
  isTaxiMasterEnabled: true,
  isWaysetEnabled: false,
  isRemoteWishlistEnabled: true,
  isSharedCartEnabled: true,
  isOrderChatEnabled: true,
  isUnpaidOrdersBannerEnabled: false,
  isUnreviewedOrdersBannerEnabled: true,
  isCashGivenEnabled: true,
  stepForWeightProductQuantity: 0.5,
};
